<div class="container">
    <app-header></app-header>
</div>

<main role="main" class="container">
    <div class="row">
        <div class="col-md-8 blog-main">
            <div class="blog-post">

                <h2 class="blog-post-title">REGIERUNG VON MITTELFRANKEN</h2>
                <h3>Grußwort zu Rosch ha-Schana 5786</h3>
                <img src="assets/img/engelhardt.jpg" class="rounded float-left" height="360px"
                    style="padding-right: 15px; padding-bottom: 15px" alt="engelhardt">
                <p>Ich grüße Sie herzlich zu Rosch ha-Schana 5786 und wünsche Ihnen, Ihren Familien,
                    Freundinnen und Freunden von ganzen Herzen ein gesegnetes Neujahrsfest.</p>
                <p>Der jüdische Jahreswechsel ist eine Zeit des Rückblicks, der Besinnung und des Neuanfangs. Es ist
                    eine gute Gelegenheit, innezuhalten und sich auf die Werte zu besinnen, die
                    unser Zusammenleben stärken: Toleranz, Respekt und Solidarität. Hier in Mittelfranken
                    begegnen sich Menschen aus vielfältigen Kulturen und Glaubensrichtungen. Genau diese
                    Vielfalt bereichert und belebt unsere Gesellschaft.</p>
                <p>Doch leider bleibt der Kampf gegen den wachsenden Antisemitismus auch im neuen Jahr
                    eine herausfordernde Aufgabe. Antisemitische Vorurteile und Angriffe sind nicht nur An-
                    griffe auf einzelne Menschen, sondern auch auf die Werte unserer freiheitlichen und de-
                    mokratischen Gesellschaft. Es ist unsere gemeinsame Verantwortung, jeglicher Form von
                    Hass und Diskriminierung entschieden entgegenzutreten und für eine Gesellschaft einzustehen, in der
                    sich alle Menschen sicher und respektiert fühlen. Jüdisches Leben ist fester
                    Bestandteil unserer Gesellschaft!</p>
                <p>Ich wünsche allen jüdischen Bürgerinnen und Bürgern für das neue Jahr Frieden, Kraft
                    und Zuversicht! Möge das Licht des Rosch ha-Schana Ihnen und Ihren Familien Orientierung und
                    Hoffnung schenken. Und mögen Glück und Gesundheit Sie durch das neue Jahr
                    5786 begleiten!</p>

                <p><b>Shana tova umetuka – ein segensreiches neues Jahr 5786</b></p>
                <p>Dr. Kerstin Engelhardt-Blum, <br />Regierungspräsidentin</p>
            </div><!-- /.blog-post -->

        </div><!-- /.blog-main -->

        <aside class="col-md-4 blog-sidebar">
            <app-info-box></app-info-box>
        </aside><!-- /.blog-sidebar -->
    </div><!-- /.row -->

</main><!-- /.container -->

<app-related-articles></app-related-articles>